import React from "react";
import { FaBell, FaHospitalSymbol } from "react-icons/fa";
import { IoMdAlert } from "react-icons/io";
import { useAuth } from "../../contexts/AuthContext";

export const Legend = (props) => {
  const { showRequest = false, showPlannedHospitalization = false } = props;
  const { checkLicense } = useAuth();
  return (
    <div className="legend">
      <span className="strong">Legenda</span>
      <ul>
        <li>Nový pacient bez vstupní kontroly</li>
        <li>Pacient s rizikovostí 1</li>
        <li>Pacient s rizikovostí 2</li>
        <li>Pacient s rizikovostí 3</li>
        <li>Pacient vyžadující vyšší pozornost</li>
        {showRequest && (
          <>
            <li>
              <span>
                <IoMdAlert />
              </span>{" "}
              Nová žádanka
            </li>
            <li>
              <span>
                <IoMdAlert />
              </span>{" "}
              Žádanka v řešení / vyřešena
            </li>
          </>
        )}
        {showPlannedHospitalization && (
          <>
            <li>
              <span>
                <FaHospitalSymbol />
              </span>
              Plánovaná hospitalizace
            </li>
          </>
        )}
        {checkLicense("penfast") && (
          <li>
            <span>
              <FaBell
                data-toggle="tooltip"
                data-placement="top"
                title="Nový PEN-FAST"
                style={{ color: "#a63a49", fontSize: 17, marginLeft: 4 }}
              />
              <FaBell
                data-toggle="tooltip"
                data-placement="top"
                title="Zhodnocen klinickým farmaceutem + challenge"
                style={{ color: "#279112", fontSize: 17, marginLeft: 4 }}
              />
              <FaBell
                data-toggle="tooltip"
                data-placement="top"
                title="Zhodnocen klinickým farmaceutem"
                style={{
                  color: "#eca100",
                  fontSize: 17,
                  marginLeft: 4,
                  marginRight: 8,
                }}
              />
            </span>{" "}
            PEN-FAST
          </li>
        )}
      </ul>
    </div>
  );
};
